<template>
  <div class="container justify-content-center mt-5">
    <div class="row d-flex justify-content-center company-product-payment-success-page">
      <div class="col-md-8 mt-3">
        <h3 class="text-center mb-4 page-title">{{ $t(LangConstants.purchase_could_not_completed_heading) }}</h3>
        <p class="mb-5 text-center page-desc">
          {{ $t(LangConstants.purchase_could_not_completed_text) }}
        </p>

        <div class="row">
          <div class="col-md-12 text-center">
            <div class="mb-2">
              <my-button fa="" :label="$t(LangConstants.contact_us_button_label)" variant="box-primary" classes="mr-1" height="64px" minwidth="400px"></my-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * Customer Payment failed page
 */
import "../../../assets/scss/companyproductpaymentsuccesspage.scss";
import MyButton from "../../../components/atoms/Button.vue";
import Constants from "../../../constants/index";

export default {
  name: "make-payment-success",
  async created() {
    // const id = this.$route.params.id;
    // console.log(id);
  },

  computed: {
    LangConstants() {
      return Constants;
    },
  },

  components: {
    MyButton,
  },
};
</script>
